import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import StatusIcon from 'Components/public/modelReleases/StatusIcon';

export default class GalleryOverlay extends React.Component {
    static propTypes = {
        type: PropTypes.oneOf(['', 'default', 'modelRelease', 'meta', 'static', 'user', 'userBasic']),
        photo: PropTypes.shape({
            caption: PropTypes.string,
            curatedCaption: PropTypes.string,
            suggestedCaption: PropTypes.string,
            selectedCaption: PropTypes.string,
            tagLinks: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string
                })
            ),
            curatedTagLinks: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string
                })
            ),
            suggestedTagLinks: PropTypes.arrayOf(
                PropTypes.shape({
                    name: PropTypes.string
                })
            ),
            user: PropTypes.shape({
                username: PropTypes.string
            })
        })
    };
    static defaultProps = {
        type: ''
    }

    mapStatusToState = {
        REJECTED: 'error',
        REQUIRED: 'warning',
        UPLOADED: 'warning',
        SENT_TO_VERIFICATION: 'success'
    }

    render() {
        const { photo } = this.props;

        switch (this.props.type) {
            case 'default':
                return (
                    <div className="component-gallery-photo-overlay">
                        <h3 className="photo-overlay-caption">
                            {photo.selectedCaption}
                        </h3>
                    </div>
                );
            case 'modelRelease':
                return (
                    <div className="component-gallery-photo-overlay model-release">
                        <h3 className="photo-overlay-top-caption">
                            <StatusIcon photo={photo} state={photo.modelReleases.status && this.mapStatusToState.hasOwnProperty(photo.modelReleases.status) ? this.mapStatusToState[photo.modelReleases.status] : 'error'} />
                        </h3>
                        <h3 className="photo-overlay-bottom-caption">
                            <span className="mission-info">{photo.mission ? photo.mission.name : ''}</span>
                            <span className="file-info">{photo.modelReleases.edges.length ? `${photo.modelReleases.edges.length} file${photo.modelReleases.edges.length !== 1 ? 's' : ''} attached` : 'No files attached'}</span>
                        </h3>
                    </div>
                );
            case 'static':
                return (
                    <div className="component-gallery-photo-overlay static">
                        <h3 className="photo-overlay-caption">
                            {photo.selectedCaption}
                        </h3>
                    </div>
                );
            case 'userAlbum':
                return (
                    <div className="component-gallery-photo-overlay user">
                        <h3 className="photo-overlay-caption">
                            {photo.selectedCaption}
                        </h3>
                    </div>
                );
            case 'user':
                return (
                    <div className="component-gallery-photo-overlay user">
                        <div className="photo-overlay-user">
                            <div className="avatar">
                                <img alt={photo.user.username} src={photo.user.avatar.w120} />
                            </div>
                            <p className="username">{photo.user.username}</p>
                        </div>
                    </div>
                );
            case 'userBasic':
                return (
                    <div className="component-gallery-photo-overlay user-basic">
                        <div className="photo-overlay-user-basic">
                            <p className="username">{photo.user.username}</p>
                        </div>
                    </div>
                );
            case 'meta':
                return (
                    <div className="component-gallery-photo-overlay metadata">
                        <div className="photo-overlay-content">
                            <p className="photo-overlay-metadata">curatedCaption: <strong>{photo.curatedCaption}</strong></p>
                            <p className="photo-overlay-metadata">curatedTags: <strong>{photo.curatedTagLinks ? photo.curatedTagLinks.map(tagLink => tagLink.name).join(', ') : ''}</strong></p>
                            <hr />
                            <p className="photo-overlay-metadata">caption: <strong>{photo.caption}</strong></p>
                            <p className="photo-overlay-metadata">tags: <strong>{photo.tagLinks ? photo.tagLinks.map(tagLink => tagLink.name).join(', ') : ''}</strong></p>
                            <hr />
                            <p className="photo-overlay-metadata">suggestedCaption: <strong>{photo.suggestedCaption}</strong></p>
                            <p className="photo-overlay-metadata">suggestedTags: <strong>{photo.suggestedTagLinks ? photo.suggestedTagLinks.map(tagLink => tagLink.name).join(', ') : ''}</strong></p>
                            <hr />
                            <p className="photo-overlay-metadata">ratingsCount: <strong>{photo.ratingsCount}</strong></p>
                            <p className="photo-overlay-metadata">averageRating: <strong>{photo.averageRating}</strong></p>
                        </div>
                    </div>
                );
            default:
                return (<div className="component-gallery-photo-overlay"></div>);
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/GalleryOverlay/index.js